import { action, computed, observable } from "mobx";
import ViewModel from "../../infrastructure/ViewModel";
import RouteList from "../../infrastructure/RouteList";
import Utils from "../../infrastructure/Utils";
import Collection from "../../infrastructure/CollectionHelper";
import AgentManagementStore from "../../store/AgentManagementStore";
import IdentityStore from "../../store/IdentityStore";
import { toast } from "react-toastify";
import { InviteAgentViewModel } from "./inviteAgent/InviteAgentViewModel";
import { routes } from "../../router";
import { DownloadAgentsRequestModel } from "../../services/AgentManagementService";
import { AgentSearch } from "../../infrastructure/enum/Common";
import UserContext, { AgentSearchUserProperties } from "../../infrastructure/UserContext";
import loggedInUser from "../../infrastructure/Auth0Authenticator";
import { Permission } from "../../infrastructure/enum/Permission";

export class AgentManagementViewModel implements ViewModel {

    @observable InviteAgentViewModel: InviteAgentViewModel =
        new InviteAgentViewModel(this);

    @observable gridApi: any;
    @observable gridApiData = new Collection<any>();
    @observable gridFilter: boolean = false;
    @observable isLoading: boolean = false;
    @observable gridFilterText: string = "";
    @observable gridSortColumn: string = "agentId";
    @observable gridSort: string = "desc";
    @observable metricData: any = { allCount: 0, activeCount: 0, prospectiveCount: 0, inActiveCount: 0, terminatedCount: 0 };
    @observable pageIndex: number = 0;
    @observable pageSize: number = 50;
    @observable totalRecords: number = 0;
    @observable gridOptions: any;
    @observable searchConditions: string = "";
    @observable isInviteAgentDialogVisible: boolean = false;
    @observable suppressSortChangedEvent: boolean = false;
    @observable isSearchFilterChanged: boolean = false;
    @observable includeMetricsDetails = true;
    @observable selectedSearchType: string = "6";
    @observable statusTypeList = [
        { label: "NPN", value: AgentSearch.Npn },
        { label: "Last Name", value: AgentSearch.LastName },
        { label: "First Name", value: AgentSearch.FirstName },
        { label: "Agent ID", value: AgentSearch.AgentId },
        { label: "Contact Options", value: AgentSearch.ContactOptions },
        { label: "DBA/Agency Name", value: AgentSearch.Dba },
        { label: "Email", value: AgentSearch.Email },
        { label: "Phone", value: AgentSearch.Phone },
        { label: "SSN", value: AgentSearch.Ssn },
        { label: "TIN", value: AgentSearch.Tin }
    ];
    @observable validSsnError: string = "";
    @observable applySort:boolean = true;
    @observable selectedMetric: string = "";
    @observable agentStatus = ["Active", "Prospective", "Inactive", "Terminated"];
    @observable selectedUserId: number | undefined = 0; 
    @observable actingUserId: number | undefined = UserContext.userId;
    @observable isUserResolved: boolean = false;
    Route = async (currentRoute: RouteList): Promise<void> => { };
    get CanClose(): boolean {
        throw new Error("Method not implemented.");
    }
    get CanRoute(): boolean {
        return true;
    }
    get IsLoaded(): boolean {
        throw new Error("Method not implemented.");
    }
    get IsLoading(): boolean {
        throw new Error("Method not implemented.");
    }
    Close(): void {
        throw new Error("Method not implemented.");
    }

    @action getAllUserDetails = async () => {
      try {
       const adGuid = loggedInUser.adUserId;
       if (!adGuid) {
        this.selectedUserId = 0;
        return;
       }
       const result = await IdentityStore.getUserByAdGuid(adGuid);
       if(result){
        this.selectedUserId = result.id;              
       }      
      } catch (e) {
            this.selectedUserId = 0;
      }    
    };

    @computed get isImpersonatingSelf(): boolean {   
        return UserContext.userId == this.selectedUserId;
    }

     @computed get canShowInviteButton(): boolean {       
        const hasPermission = Utils.hasUserPermission(Permission.InviteAgent); 
        return hasPermission && this.isImpersonatingSelf;
    }

    @action Load = async () => {
        window.scrollTo(20, 0);
    }

    @action onFilterChanged = async () => {
        let gridFilter = false;
        this.gridApi.getAllDisplayedColumns().map(
            function (col: any) {
                if (col.isFilterActive() == true) {
                    gridFilter = true;
                }
            }
        );
        this.gridFilter = gridFilter;
    }
    @action resetGrid = async () => {
        document.querySelectorAll('.custom-menu-item>div').forEach(btn => btn.classList.remove('active'));
        const firstElement = document.querySelectorAll('.custom-menu-item > div');
        if (firstElement !== null && firstElement.length > 0) {
            firstElement[0].classList.add('active');
        }
        this.selectedMetric = "";
        this.gridSortColumn = "agentId";
        this.gridSort = "desc";
        this.pageIndex = 0;
        this.pageSize = 50;
        this.suppressSortChangedEvent = true;
        if (this.gridApi) {
            const colIds = [
            "agentId",
            "agent",
            "agentStatus",
            "npn",
            "immediateUpline",
            "phoneNumber",
            "emailAddress"
            ];
            this.gridApi.setFilterModel(null);
            colIds.forEach(colId => {
             this.gridApi.destroyFilter(colId);
            });
            this.gridApi.onFilterChanged();
            this.gridApi.refreshHeader();
            this.gridApi.resetColumnState();
            this.gridApi.applyColumnState({
            state: [{ colId: this.gridSortColumn, sort: "desc" }],
            });
        }
        setTimeout(() => {
            this.suppressSortChangedEvent = false;
        }, 100);

        this.selectedSearchType = await this.getHeaderSearchType();
        this.gridFilterText = "";
        this.gridFilter = false;
        this.searchConditions = "";
        this.includeMetricsDetails = true;
        await this.setStatusValue(this.selectedMetric, true);
    }
    @action ongridReset = async () => {
        this.applySort = true;
        this.pageIndex = 0;
        setTimeout(() => {
            this.suppressSortChangedEvent = false;
        }, 100);
        this.gridFilter = false;
        this.suppressSortChangedEvent = true;
        this.includeMetricsDetails = false;
        this.gridApi.setFilterModel(null);
        this.gridApi.resetColumnState();
        this.gridApi.applyColumnState({
            state: [{ colId: this.gridSortColumn, sort: this.gridSort }]
        });
        this.gridApi.paginationGoToPage(this.pageIndex);
        this.setStatusValue(this.selectedMetric,true);
    }
   
    @action onPaginationChanged = async (params: any = null, pageIndex: number) => {
        this.pageIndex = pageIndex;
        await this.getAllDetailsMetrics();
        this.gridApi.paginationGoToPage(pageIndex);

    };
    @action onRowsPerPage = async (value: number) => {
        this.pageIndex = 0;
        this.pageSize = value;
        this.gridApi.paginationGoToPage(0)
        await this.getAllDetailsMetrics();       
    };
    
    @action setGridApi = (api: any) => {
        this.gridApi = api;
    };

    @action setInviteAgentDialogVisibility = async (value: boolean) => {
        this.isInviteAgentDialogVisible = value;
        if (value) {
            this.InviteAgentViewModel.Load();
        }
    };

    @action addAgent = async () => {
        routes.addAgent.push();
    };
    @action showMaps = async () => {
        await Utils.getApiKey();
        routes.mapsView.push();
    };

    @action showDetails = async (
        agentId: number | undefined,
    ) => {
        sessionStorage.setItem("createlog", "true");
        routes.agentDetails.push({
            agentId: "" + agentId,
        });
    };
    @action noRecordsFound() {
        this.totalRecords = 0
    }

    @action setSearchDropdown= async (value: string) => {
        if (value !== "3") {
            this.validSsnError = "";
        }
        this.selectedSearchType = value;
        this.setAgentSearchUserProperties();
        if(this.gridFilterText.length > 0){
            await this.getAllDetailsMetrics();
        }
    }
    @action setAgentSearchUserProperties = async () => {
        let host = Utils.getHost();
        var userId = UserContext.getUserId();
        let userProperties: AgentSearchUserProperties = {
          buName: host,
          userId: userId,
          searchType: this.selectedSearchType,
        };
        var data = JSON.stringify(userProperties);
        localStorage.setItem('agentSearchType', data);
    };

    @action getHeaderSearchType = async () => {
          var result = "6";
          const agentSearchUserProperties = localStorage.getItem("agentSearchType");
          if (agentSearchUserProperties) {
            const userprop: AgentSearchUserProperties = JSON.parse(agentSearchUserProperties);
            result = userprop && userprop.searchType ? userprop.searchType : "6";
          }
          return result;
    }


    formatPhoneNumber = (phoneNumberString: string) => {
        var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return match[0];
        }
        return phoneNumberString;
      };
      
    removeDash = (input: string) => {
        return input.replace(/-/g, "");
    };
    @action getAllDetailsMetrics = async () => {
        this.isLoading = true;
        if (this.selectedSearchType === AgentSearch.Phone) {
            this.gridFilterText = this.formatPhoneNumber(this.gridFilterText);
            this.gridFilterText = this.removeDash(this.gridFilterText);
        }
        if (this.selectedSearchType === AgentSearch.Ssn || this.selectedSearchType === AgentSearch.Tin) {
            this.gridFilterText = this.gridFilterText.replace(/-/g, "").trim();
            if (this.gridFilterText.length < 3) {
                this.validSsnError = "Please enter minimum 3 digits";
                this.noRecordsFound();
            return;
            } else {
               this.validSsnError = "";
            }
        }
        var searchTypeParam = this.gridFilterText != "" ? this.selectedSearchType:null;
        let sortAscending: boolean = this.gridSort === "asc" ? true : false;
        try {
            let response = await AgentManagementStore.getAllAgentDetailsAsync(
                searchTypeParam ? searchTypeParam.toString() : "",
                this.gridFilterText,
                this.pageIndex+1,
                this.includeMetricsDetails,
                this.pageSize,
                this.gridSortColumn,
                sortAscending,
                this.searchConditions
                );
            /* console.log('searchConditions: '+this.searchConditions); */
            if (response && response.agentMetrics) {
                const activeElement = document.querySelector('.custom-menu-item > div.active');
                setTimeout(() => {
                    if (activeElement) {
                        activeElement.classList.add('active');
                    }
                },100);
                this.metricData = response.agentMetrics;
            } 
            if (response && response.agentDetails) {
                    this.totalRecords = (response.agentDetails.recordCount) ? response.agentDetails.recordCount : 0
                    this.gridApiData.values = response.agentDetails.data || [];
            }
            else {
                    this.gridApiData.values = [];
            }
            if(this.applySort) {
                this.gridApi.applyColumnState({state:[{colId:this.gridSortColumn, sort:this.gridSort}]});
                setTimeout(() => {
                this.applySort = false;
                },100)
            }
            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
            toast.error('Agents:'+error, {className:"custom-toaster", autoClose:4000});
        }
    }
    @action toDownloadAgentsModel = () => {
        let sortAscending: boolean = this.gridSort === "asc" ? true : false;
        return {
            sortColumn: this.gridSortColumn,
            sortAscending: sortAscending,
            fullTextFilter: this.searchConditions,
            searchType: this.gridFilterText !="" ? this.selectedSearchType:0,
            searchText: this.gridFilterText
        } as DownloadAgentsRequestModel;

    }
    @action downloadAgents = async () => {
        try {
            this.isLoading = true;
            let res = await AgentManagementStore.downloadAgents(
                this.toDownloadAgentsModel()
            );
            this.isLoading = false;
            Utils.saveDownloadedReportFile(res, "Agent Management");
            Utils.showSuccessToaster("Agent List downloaded.", 7000);
        } catch (error) {
            this.isLoading = false;
        }
    };

    @action onGridReady = async () => {
        await this.getAllUserDetails();
        this.applySort = true;
        this.gridSortColumn = "agentId";
        this.gridSort = "desc";
        this.pageIndex = 0;
        this.pageSize = 50;   
        this.includeMetricsDetails = true;
        this.selectedSearchType = await this.getHeaderSearchType();
        this.gridFilterText = "";
        this.selectedMetric = "";
        this.searchConditions = this.selectedMetric  && "agentStatus=" + this.selectedMetric;
        this.gridFilter = false;
        this.suppressSortChangedEvent = false;
      }

    @action setStatusValue = async (value:string,isDisabled:boolean) => {
        var agentAllStatus:any[] = [];
          if (!this.selectedMetric) {
            agentAllStatus = [...this.agentStatus];
          }else{
            agentAllStatus = [value];
          }
          if (this.gridApi) {
              const filterInstance = await this.gridApi.getFilterInstance("agentStatus");
              if (filterInstance && filterInstance.floatingFilterCompRef) {
                filterInstance.floatingFilterCompRef.setValues(agentAllStatus,value);
              }
              if (filterInstance.floatingFilterCompRef.setDisabled && isDisabled) {
                filterInstance.floatingFilterCompRef.setDisabled(!!value);
              }
          }
      }
};
